import { NavLink } from "react-router-dom";

const quickLinks = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Courses", href: "/courses" },
  { label: "Events", href: "/" },
  { label: "Admissions", href: "/admissions" },
  { label: "Gallery", href: "/gallery" },
  { label: "Opportunities", href: "/opportunities" },
  { label: "Contact", href: "/contact" },
];

const programs = [
  { label: "Information Technology", href: "/courses" },
  { label: "Film Studies", href: "/courses" },
  { label: "Graphic Design", href: "/courses" },
];

const socials = [
  {
    label: "Facebook",
    href: "#",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
      </svg>
    ),
  },
  {
    label: "Instagram",
    href: "#",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    label: "LinkedIn",
    href: "#",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z" />
        <circle cx="4" cy="4" r="2" />
      </svg>
    ),
  },
  {
    label: "YouTube",
    href: "#",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.96-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" />
        <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="white" />
      </svg>
    ),
  },
];

export default function Footer() {
  return (
    <footer className="footer" aria-label="Site footer">
      <div className="footer__main">
        <div className="footer__inner">
          <div className="footer__brand">
            <NavLink to="/" className="footer__logo" aria-label="Mokorotlo College home">
              <img src="/logo.jpeg" alt="Mokorotlo College" width={44} height={44} className="footer__logo-img" loading="lazy" />
              <div>
                <p className="footer__logo-main">Mokorotlo College</p>
                <p className="footer__logo-sub">Of Creative Technology</p>
              </div>
            </NavLink>
            <p className="footer__tagline">
              Empowering the next generation of creative and technology professionals in Southern Africa.
            </p>
            <div className="footer__socials" aria-label="Social media links">
              {socials.map((s) => (
                <a key={s.label} href={s.href} className="footer__social" aria-label={s.label} target="_blank" rel="noopener noreferrer">
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          <div className="footer__col">
            <h3 className="footer__col-title">Quick Links</h3>
            <ul className="footer__links">
              {quickLinks.map((l) => (
                <li key={l.label}>
                  <NavLink to={l.href} className="footer__link">{l.label}</NavLink>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__col">
            <h3 className="footer__col-title">Programs</h3>
            <ul className="footer__links">
              {programs.map((p) => (
                <li key={p.label}>
                  <NavLink to={p.href} className="footer__link">{p.label}</NavLink>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__col">
            <h3 className="footer__col-title">Contact Us</h3>
            <ul className="footer__contact-list">
              <li>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                <span>
                  <a href="https://maps.google.com/?q=BEDCO+Leribe,+Hlotse,+42FV%2BQP4" target="_blank" rel="noopener noreferrer">
                    BEDCO Leribe, Hlotse, Room 5 — Plus Code: 42FV+QP4
                  </a>
                </span>
              </li>
              <li>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16.92z"/></svg>
                <span>+266 5627 7876 (WhatsApp)</span>
              </li>
              <li>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                <span>mcct@mokorotlocollege.co.ls</span>
              </li>
            </ul>
            <a
              className="footer__map-link"
              href="https://maps.google.com/?q=BEDCO+Leribe,+Hlotse,+42FV%2BQP4"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Open Mokorotlo College location in Google Maps"
            >
              Open in Google Maps
            </a>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="footer__bottom-inner">
          <p className="footer__copy">
            © {new Date().getFullYear()} Mokorotlo College of Creative Technology. All rights reserved.
          </p>
          <p className="footer__dev">
            Developed by <span className="footer__dev-name">Khauhelo Mosehle</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
